export interface BasicResponse{
    status: 'SUCCESS' | 'ERROR',
    error: {
        'has-error': boolean,
        error?: string
    },
    response: unknown
}


export interface MessageResponse extends BasicResponse{
    response: string
}
export const GetToken = () => {
    const token:string = localStorage.getItem('currentUser')
        ? JSON.parse( localStorage.getItem('currentUser') + '' ).token
        : 'PTM';

    return token;
};
